var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8H10C8.4087 8 6.88258 8.63214 5.75736 9.75736C4.63214 10.8826 4 12.4087 4 14V34C4 35.5913 4.63214 37.1174 5.75736 38.2426C6.88258 39.3679 8.4087 40 10 40H38C39.5913 40 41.1174 39.3679 42.2426 38.2426C43.3679 37.1174 44 35.5913 44 34V14C44 12.4087 43.3679 10.8826 42.2426 9.75736C41.1174 8.63214 39.5913 8 38 8ZM37.18 12L25.42 23.76C25.2341 23.9475 25.0129 24.0962 24.7692 24.1978C24.5254 24.2993 24.264 24.3516 24 24.3516C23.736 24.3516 23.4746 24.2993 23.2308 24.1978C22.9871 24.0962 22.7659 23.9475 22.58 23.76L10.82 12H37.18ZM40 34C40 34.5304 39.7893 35.0391 39.4142 35.4142C39.0391 35.7893 38.5304 36 38 36H10C9.46957 36 8.96086 35.7893 8.58579 35.4142C8.21071 35.0391 8 34.5304 8 34V14.82L19.76 26.58C20.885 27.7036 22.41 28.3347 24 28.3347C25.59 28.3347 27.115 27.7036 28.24 26.58L40 14.82V34Z",
    fill: "#FBF9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.59a0c22762119f21c58183e42d428831.svg";
export { ForwardRef as ReactComponent };